import React from 'react';
import { BookOpen, Store, Trophy, Settings as SettingsIcon, Bot } from 'lucide-react';

interface HeaderActionButtonsProps {
  onShowShop: () => void;
  onShowChallenges: () => void;
  onShowRecipeBook: () => void;
  onShowSettings: () => void;
  onToggleAI: () => void;
  aiBarista: any;
}

const HeaderActionButtons: React.FC<HeaderActionButtonsProps> = ({
  onShowShop,
  onShowChallenges,
  onShowRecipeBook,
  onShowSettings,
  onToggleAI,
  aiBarista,
}) => {
  return (
    <div className="flex gap-1 sm:gap-2">
      <button
        onClick={onShowShop}
        data-tutorial-id="shop-button"
        className="header-button bg-text-secondary px-2 sm:px-4 py-2 rounded-lg font-bold flex items-center gap-2 text-sm sm:text-base hover:bg-opacity-80 transition-colors min-h-[44px]"
        title="Shop"
      >
        <Store size={16} />
        {/* Show text label only on lg and above to keep header in one line on smaller breakpoints */}
        <span className="hidden lg:inline">Shop</span>
      </button>
      <button
        onClick={onShowChallenges}
        className="header-button bg-text-secondary px-2 sm:px-4 py-2 rounded-lg font-bold flex items-center gap-2 text-sm sm:text-base hover:bg-opacity-80 transition-colors min-h-[44px]"
        title="Challenges"
      >
        <Trophy size={16} />
        <span className="hidden lg:inline">Challenges</span>
      </button>
      <button
        data-tutorial-id="recipe-book-button"
        onClick={onShowRecipeBook}
        className="header-button bg-text-secondary px-2 sm:px-4 py-2 rounded-lg font-bold flex items-center gap-2 text-sm sm:text-base hover:bg-opacity-80 transition-colors min-h-[44px]"
        title="Recipes"
      >
        <BookOpen size={16} />
        <span className="hidden lg:inline">Recipes</span>
      </button>
      {aiBarista.level > 0 && (
        <button
          onClick={onToggleAI}
          title={`AI Barista: ${aiBarista.active ? 'ON' : 'OFF'}`}
          className={`p-2 rounded-lg flex items-center transition-colors min-h-[44px] min-w-[44px] justify-center ${
            aiBarista.active ? 'bg-success text-white animate-pulse' : 'bg-text-secondary'
          }`}
        >
          <Bot size={16} />
          {/* Icon-only at sm/md; no text here to keep compact */}
        </button>
      )}
      <button
        onClick={onShowSettings}
        className="header-button bg-text-secondary p-2 rounded-lg flex items-center hover:bg-opacity-80 transition-colors min-h-[44px] min-w-[44px] justify-center"
        title="Settings"
      >
        <SettingsIcon size={16} />
        {/* Icon-only on small/medium; text label only on lg and up */}
        <span className="hidden lg:inline ml-2">Settings</span>
      </button>
    </div>
  );
};

export default HeaderActionButtons;
